import { axiosSwagger } from "@/axios";



export const state = {
  // set location
  setLocation: {
    loading: false,
    data: [],

    selectedData: null,
  }
}


export const getters = {
}


export const mutations = {
  // SET LOCATION
  loading: (state, loading) => {
    state.setLocation.loading = loading;
  },
  setData: (state, data) => {
    state.setLocation.data = data;
  },
  selectData: (state, data) => {
    state.setLocation.selectedData = data;
  },
}


export const actions = {
  // SET LOCATION
  async readSetLocation({ commit }, id) {
    commit("loading", true);

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    if(id !== null){
      return await axiosSwagger
        .get(`/api/FileLocation/Child/${id}/${userData?.deliveryUnit?.id}`)
        .then((response) => {
          commit("setData", response.data);
          commit("loading", false);

          return response;
        })
        .catch(() => {
          commit("loading", false);
        });
    }
    else{
      return await axiosSwagger
        .get(`/api/FileLocation/My/${userData?.deliveryUnit?.id}`)
        .then((response) => {
          commit("setData", response.data);
          commit("loading", false);

          return response;
        })
        .catch(() => {
          commit("loading", false);
        });
    }
  }
}

